
  import { Component, Prop, Vue } from "vue-property-decorator";

  import EmployeeDropdownOption from "@/entities/EmployeeDropdownOption";
  import MultiselectAvatar from "@/components/autocompleteMultiselects/MultiselectAvatar.vue";
  import RemoveSelectedItemButton from "@/components/autocompleteMultiselects/RemoveSelectedItemButton.vue";

  @Component({
    components: {
      RemoveSelectedItemButton,
      MultiselectAvatar,
    }
  })
  export default class MultiselectAvatarTag extends Vue {
    @Prop({ type: Object, required: true }) readonly option!: EmployeeDropdownOption;
  }
